import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import CLIUpload from '../../_snippets/cli/upload.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`You will then need to upload the modified assets to PostHog.`}</p>
    <CLIUpload path="./path/to/assets" mdxType="CLIUpload" />
    <h4 {...{
      "id": "serve-injected-assets"
    }}>{`Serve injected assets`}</h4>
    <p>{`You `}<em parentName="p">{`must`}</em>{` serve the injected assets in deployed production app. The injected metadata is used during error capture to identify the correct source map to use. We suggest you upload source maps right after your production build in CI.`}</p>
    <p>{`If you serve a copy of the bundled assets as they were prior to running `}<inlineCode parentName="p">{`posthog-cli sourcemap inject`}</inlineCode>{`, we won't be able to use the uploaded sourcemap to unminify or demangle your stack traces.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      